/*
    *   NavScroll
    *
    *   Chris Bastin - 2019
    *
    *   Attributes needed:
    *
    *   Nav Items -         data-scroll-nav="{{ id }}"
    *   Content Blocks -    data-scroll-block="{{ id }}"
    *
    *   Containers must not have "position:relative" and content blocks should have an accurate offsetTop. If unavoidable, edit script to add necessary padding.
    *
    *   Will add 'active' classname to nav items when the center of the screen has scrolled past the top of each content block
*/

class NavScroll {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._sections = null
    }

    onInit () {
        this._sections = this._elem.querySelectorAll('[data-scroll-block]')
        this._navs = this._elem.querySelectorAll('[data-scroll-nav]')
        if (this._sections.length > 0 && this._navs.length > 0) {
            window.addEventListener('scroll', (e) => { this.onScroll(e) })
        }
    }

    onScroll (e) {
        let activeSection = null
        for (let section of this._sections) {
            if (this.screenCenter() > section.offsetTop) {
                activeSection = section
            }
        }
        if (!activeSection) {
            if (this.screenCenter() > this.elemBottom(this._elem)) {
                activeSection = this._sections[this._sections.length - 1]
            } else {
                activeSection = this._sections[0]
            }
        }
        let activeID = activeSection.dataset.scrollBlock
        for (let nav of this._navs) {
            if (nav.dataset.scrollNav === activeID) {
                nav.classList.add('active')
            } else {
                nav.classList.remove('active')
            }
        }
    }

    screenCenter () {
        return window.scrollY + (window.innerHeight / 2)
    }
}

export default NavScroll



// WEBPACK FOOTER //
// ./src/resources/scripts/components/NavScroll.js